import React from "react";
import Field from "@lib/model/configurator/Field";

export default class Apartment extends React.Component {
    constructor(props) {
        super(props);
        this.step = this.props.step;
        this.renderField = this.props.renderFieldv2;
    }

    render() {
        return (
            <React.Fragment>
                <div className="row row-no-gutter">
                    <div className="column-6">
                        {this.renderField("t1Studio")}
                        {this.renderField("t1")}
                        {this.renderField("t2")}
                        {this.renderField("t3")}
                        {this.renderField("t4")}
                        {this.renderField("t5")}
                        {this.renderField("t6")}
                    </div>
                    <div className="column-6">
                        {this.renderField("park")}
                        {this.renderField("standing")}
                        {this.renderField("situation")}
                    </div>
                </div>

                <div className="row row-no-gutter" style={{paddingTop: "20px"}}>
                    <div className="column-6">
                        {this.renderField("tdhw")}
                        {this.renderField("tcw")}
                    </div>
                    <div className="column-6">
                        {this.renderField("maxChargingTime")}
                        {this.renderField("primaryTank")}
                        {this.renderField("aquaEfficiency", false)}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderField(fieldName, includeLabel = true) {
        const field = new Field(`needsCalculation.needsCalculationInput.${fieldName}`, this.step);

        return (
            <div className="heating-horizontal-field">
                <div className="heating-horizontal-field-label">
                    {includeLabel && <span> {field.label} </span>}
                </div>
                <div className="heating-horizontal-field-input">
                    <span className="input">{this.renderFieldv2(field)}</span>
                    <span className="unit">{field.unit}</span>
                </div>
            </div>
        )
    }
}
